import { render, staticRenderFns } from "./WLANBCDRequestForm.vue?vue&type=template&id=660cefcc&scoped=true"
import script from "./WLANBCDRequestForm.vue?vue&type=script&lang=js"
export * from "./WLANBCDRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660cefcc",
  null
  
)

export default component.exports